import { Panel } from 'src/shared/components/panel';
import { RoundInfoForm } from './RoundInfoForm';

/**
 * 회차 정보
 */
export const RoundInfo = () => {
  return (
    <div className="flex flex-col gap-16 mt-12">
      <Panel title="회차 정보" isOpen>
        <RoundInfoForm />
      </Panel>
    </div>
  );
};
